import { createClient } from '@supabase/supabase-js'

// Create a single supabase client for interacting with your database
const SUPABASE_URL = process.env?.VUE_APP_SUPABASE_URL || ''
const SUPABASE_ANON_KEY = process.env?.VUE_APP_SUPABASE_ANON_KEY || ''

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY)